import { mode } from "@chakra-ui/theme-tools";
export const globalStyles = {
  colors: {
    brand: {
      50: "#EBF3FF",
      100: "#D6E6FE",
      200: "#ADC8FD",
      300: "#6EA4FA",
      400: "#2575FC",
      500: "#0756C9",
      600: "#0544A1",
      700: "#043680",
      800: "#032860",
      900: "#021B40",
    },
    brandScheme: {
      50: "#EBF3FF",
      100: "#D6E6FE",
      200: "#ADC8FD",
      300: "#6EA4FA",
      400: "#2575FC",
      500: "#0756C9",
      600: "#0544A1",
      700: "#043680",
      800: "#032860",
      900: "#021B40",
    },
    brandTabs: {
      50: "#EBF3FF",
      100: "#D6E6FE",
      200: "#ADC8FD",
      300: "#6EA4FA",
      400: "#2575FC",
      500: "#0756C9",
      600: "#0544A1",
      700: "#043680",
      800: "#032860",
      900: "#021B40",
    },
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#E9EDF7",
      500: "#8F9BBA",
      600: "#A3AED0",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EBF3FF",
      100: "#D6E6FE",
      200: "#ADC8FD",
      300: "#6EA4FA",
      400: "#2575FC",
      500: "#0756C9",
      600: "#0544A1",
      700: "#043680",
    },
    orange: {
      100: "#FFF6DA",
      500: "#E0A82E",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
    },
    navy: {
      50: "#d0dcfb",
      100: "#aac0fe",
      200: "#a3b9f8",
      300: "#728fea",
      400: "#3652ba",
      500: "#1b3bbb",
      600: "#24388a",
      700: "#1B254B",
      800: "#111c44",
      900: "#0b1437",
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        fontFamily: "DM Sans",
        letterSpacing: "-0.5px",
      },
      input: {
        color: "gray.700",
      },
      html: {
        fontFamily: "DM Sans",
      },
    }),
  },
};
